<template>
  <div class="NewTrade">
    <program-head :isNeedBack="true" />

    <div v-if="isSuccess">
      <success-trade />
    </div>
    <div v-else>
      <form class="gen-form" data-form="profile">
        <div class="gen-fieldset__item">
          <label>Type</label>
          <div class="gen-select-container ">
            <div class="ui-ddbox ui-ddbox-select">
              <button class="ui-ddbtn">
                <span class="ui-ddbtnvalue" v-if="listTypes && listTypes[1] && !currentType">
                  {{ listTypes[1].name }}
                </span>
                <span v-else>{{ currentType.name }}</span>
                <i class="fa fa-caret-down" aria-hidden="true"></i>
              </button>
              <div class="ui-ddbody">
                <div class="ui-ddsection ui-assignedtoList">
                  <ul>
                    <li v-for="(item, index) in listTypes" :key="index" @click="setType(item)">
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gen-fieldset__item">
          <label>Commited $</label>
          <input v-model="form.committed" type="text">
        </div>
        <div class="gen-fieldset__item">
          <label>Start date</label>
          <input v-model="form.start_date" type="text">
        </div>
        <div class="gen-fieldset__item">
          <label>End date</label>
          <input v-model="form.end_date" type="text">
        </div>
        <div class="gen-fieldset__item">
          <label>Asset</label>
          <input v-model="form.asset" type="text">
          <!--          <div class="gen-select-container ">-->
          <!--            <div class="ui-ddbox ui-ddbox-select">-->
          <!--              <button class="ui-ddbtn">-->
          <!--                <span class="ui-ddbtnvalue">-->
          <!--                  Asset-->
          <!--                </span>-->
          <!--                <i class="fa fa-caret-down" aria-hidden="true"></i>-->
          <!--              </button>-->
          <!--              <div class="ui-ddbody">-->
          <!--                <div class="ui-ddsection ui-assignedtoList">-->
          <!--                  <ul>-->
          <!--                    <li>-->
          <!--                      BTCUSD-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                      BTCUSD-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                      BTCUSD-->
          <!--                    </li>-->
          <!--                  </ul>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div class="gen-fieldset__item">
          <label class="radio-title">Operation</label>
          <div class="radio-holder">
            <div class="radio-block">
              <input v-model="form.operation" value="buy" type="radio" id="test1" name="radio-group" checked>
              <label for="test1">BUY</label>
            </div>
            <div class="radio-block">
              <input v-model="form.operation" value="sell" type="radio" id="test2" name="radio-group">
              <label for="test2">SELL</label>
            </div>
          </div>
        </div>
        <div class="gen-fieldset__item current">
          <label>Current price $</label>
          <span>(will be set automatically on creation)</span>
        </div>
        <div class="gen-fieldset__item">
          <label>Special price $</label>
          <input v-model="form.special_price" type="text" name="lastcalldate">
        </div>
      </form>
      <div class="gen-form-post-btns">
        <div class="button-holder submit-btn">
          <button class="btn" @click.prevent="createProgram"><span>Create</span></button>
        </div>
        <div v-if="error" class="error">{{error}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SuccessTrade from "./SuccessTrade";
import ProgramHead from "./ProgramHead";
import moment from "moment";
import LeadDataService from "../../../../services/lead-data.service";

export default {
  name: "NewTrade",
  components: {ProgramHead, SuccessTrade},
  data() {
    return {
      timeFormat: 'YYYY-MM-DD hh:mm:00',
      isSuccess: false,
      currentType: '',
      error: '',
      form: {
        action: 'add',
        login: '',
        start_date: '',
        end_date: '',
        type: '',
        committed: '',
        asset: '',
        special_price: '',
        operation: 'buy',
      }
    }
  },
  computed: {
    currentProgram: {
      get() {
        return this.$store.state.currentProgram;
      },
      set(value) {
        this.$store.commit('setter', {currentProgram: value})
      }
    },
    listTypes() {
      return this.$store.state.listTypes;
    },
  },
  mounted() {
    this.$store.dispatch('getTypesList');
    this.changeDefaultTime();
  },
  methods: {
    setType(item) {
      this.currentType = item;
    },
    createProgram() {
      this.form.type = this.currentType.id || this.listTypes[1].id;
      this.form.login = this.Lead.info.login;

      LeadDataService.getPrograms(this.form).then((res) => {
        this.isSuccess = res.data.result;
        this.currentProgram = res.data.data;
      }).catch((error) => {
        this.error = error.response.data.message;
      })
    },
    changeDefaultTime() {
      this.form.start_date = moment().format(this.timeFormat);
      this.form.end_date = moment().add(1, 'M').format(this.timeFormat);
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles/components/variables";

.dark--theme {
  .SpTradesTab {
    .NewTrade {
      .button-holder {
        &.top-btn-holder {
          .btn {
            border: 1px solid #9ed5fb !important;
            box-shadow: 0 3px 4px rgba(158, 213, 251, 0.6) !important;
          }
        }
      }
    }
  }
}

.SpTradesTab {
  .NewTrade {
    .button-holder {
      &.top-btn-holder {
        .btn {
          border: 1px solid #ce3d7d !important;
          box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1) !important;

          &:after {
            display: none;
          }
        }
      }
    }
  }
}

.NewTrade {
  .radio-title {
    margin-bottom: 10px;
  }

  .gen-fieldset__item {
    &.current {
      label {
        margin-bottom: 8px;
      }

      span {
        color: #8d8d8d;
      }
    }
  }

  .button-holder {
    text-align: right;
    margin-bottom: 24px;

    .btn {
      font-size: 14px;
      color: $magenta-1;
      font-weight: 500;
    }

    &.submit-btn {
      display: block;
    }
  }

  .radio-holder {
    display: flex;

    .radio-block {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }

      label {
        color: $dark-purple;
        font-size: 16px;
        text-transform: uppercase;
      }
    }
  }

  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #666;
  }

  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 11px;
    height: 11px;
    border: 1px solid #aeaeae;
    border-radius: 50%;
    background: #fff;
  }

  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: '';
    width: 5px;
    height: 5px;
    background: $dark-purple;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 4px;
    border-radius: 50%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  [type="radio"]:not(:checked) + label::after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  [type="radio"]:checked + label:after {
    opacity: 1;
  }
}
</style>
